import React, { useEffect, useState, useRef } from 'react'
import Layout from './Layout'
import SlideListItem from './SlideListItem'
import { FETCH_SLIDES, SAVE_SLIDE } from '../redux/manageSlidesReducer'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { RootReducer } from '../redux/rootReducer'
import CreateSlideButton from './CreateSlideButton'
import { Slide } from '../types'
import DraggableList from 'react-draggable-list'
import DraggableItem from './DraggableItem'
import { REORDER_SLIDES } from '../redux/manageSlidesReducer'
import SlideEditor from './SlideEditor'
import ButtonWithLoader from './ButtonWithLoader'
import SlidePreview from './SlidePreview'
import AddImageButton from './AddImageButton'
import Book from '../icons/Book'
import RemoveSlideButton from './RemoveSlideButton'

const LessonPlanScreen = () => {
  const dispatch = useDispatch()
  const { lessonPlanId } = useParams()
  const containerRef = useRef<HTMLDivElement>(null)
  const [slides, setSlides] = useState<Slide[]>([])
  useEffect(() => {
    if (lessonPlanId) {
      dispatch(FETCH_SLIDES({ lessonPlanId: lessonPlanId }))
    }
  }, [dispatch, lessonPlanId])

  const reducerSlides = useSelector((state: RootReducer) => {
    if (lessonPlanId) {
      return state.manageSlidesReducer.slides[lessonPlanId] || []
    }
    return []
  })

  const _onListChange = (newList: Slide[]) => {
    setSlides(newList)
    if (lessonPlanId) {
      dispatch(REORDER_SLIDES({ lessonPlanId: lessonPlanId, ids: newList.map((slide) => slide.id) }))
    }
  }

  useEffect(() => {
    setSlides(reducerSlides)
  }, [reducerSlides])

  return (
    <Layout>
      <div>
        <div className="flex justify-end gap-2">
          <RemoveSlideButton />
          <Link to="exercises" className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer">
            <div className="text-white w-5 h-5">
              <Book />
            </div>
            <div className="text-14 font-semibold text-white">Exercises</div>
          </Link>
          <CreateSlideButton />
          <AddImageButton />
        </div>
        <div className="flex">
          <div className="min-w-[300px]">
            <DraggableList
              itemKey="id"
              //@ts-ignore
              template={DraggableItem}
              list={slides}
              onMoveEnd={(newList: any) => _onListChange(newList)}
              container={() => containerRef.current}
              commonProps={{
                component: SlideListItem
              }}
            />
          </div>
          <div className="w-2" />
          <div className="flex-1">
            <div className="h-4" />
            <SlideEditor />
            <div className="h-4" />
            <SlidePreview />
            <div className="h-4" />
            <ButtonWithLoader
              label="Save"
              onClick={() => {
                if (lessonPlanId) {
                  dispatch(SAVE_SLIDE({ lessonPlanId: lessonPlanId }))
                }
              }}
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default LessonPlanScreen
